import { getCookie, setCookie } from '@/features/consent/utils/cookies';
import { resolveSupportedLanguage, type SupportedLanguageCode } from './config';

export const LANGUAGE_COOKIE_NAME = 'shell-language';
export const LANGUAGE_COOKIE_LIFETIME_DAYS = 365;

export const readLanguagePreference = (): SupportedLanguageCode | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  const storedLanguage = getCookie(LANGUAGE_COOKIE_NAME);
  return storedLanguage ? resolveSupportedLanguage(storedLanguage) : null;
};

export const writeLanguagePreference = (language: SupportedLanguageCode): void => {
  if (typeof document === 'undefined') {
    return;
  }

  setCookie(LANGUAGE_COOKIE_NAME, language, LANGUAGE_COOKIE_LIFETIME_DAYS);
};
